const initState = () => {
  return {
    entityEventTaskSearchCriteria: {
      entityType: '',
      entityEventId: '',
      entityInstanceId: '',
      targetProcessorId: '',
      status: '',
      source: '',
      fromEventTime: '',
      toEventTime: ''
    },
    entityEventTaskSearchResults: {
      items: [],
      totalItems: 0,
      isInit: true
    }
  }
}

const searchEntityEventTasks = {
  state: initState(),
  mutations: {
    updateEntityEventTaskSearchResults (state, searchResults) {
      state.entityEventTaskSearchResults = searchResults
    },
    resetEntityEventTaskSearchCriteria (state) {
      Object.assign(state.entityEventTaskSearchCriteria, initState().entityEventTaskSearchCriteria)
    }
  },
  getters: {
    entityEventTaskSearchCriteria: state => state.entityEventTaskSearchCriteria,
    entityEventTaskSearchResults: state => state.entityEventTaskSearchResults
  }
}

export default searchEntityEventTasks
